module.exports = __webpack_public_path__ + "01_long_brown.7db6b374.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_long_brown.png
// module id = yTGx
// module chunks = 0